// @flow
export const ACTIONS = {
    NOTIFICATIONS_LOADED: 'notifications-loaded',
    NOTIFICATIONS_VIEWED: 'notifications-viewed',
    NOTIFICATIONS_READ: 'notifications-read',
    SINGLE_NOTIFICATION_READ: 'single-notification-read',
    RESET_ALL: 'RESET_ALL'
};

export const NOTIFICATION_TYPE_ENUM = {
    SESSION_PUBLISHED_TEAM: 1,
    SESSION_PUBLISHED_ONE_TO_ONE: 2,
    FEED_COMMENT_TEAM: 3,
    FEED_COMMENT_ONE_TO_ONE: 4,
    FEED_REPLY_AUTHOR_TEAM: 5,
    FEED_REPLY_DISCUSSION_TEAM: 6,
    FEED_REPLY_ONE_TO_ONE: 7,
    FEED_LIKE_TEAM: 8,
    FEED_LIKE_ONE_TO_ONE: 9,
    EXERCISE_COMMENT: 10,
    SESSION_REPLY: 11,
    SESSION_REPLY_LIKE: 12,
    SESSION_SUMMARY_COMMENT: 13,
    SESSION_SUMMARY_COMMENT_SHARE_WITH_TEAM: 14,
    SESSION_LIKE: 15,
    LEADERBOARD_LIKE: 16,
    SESSION_PUBLISHED_BATCH_TEAM: 17,
    SESSION_PUBLISHED_BATCH_ONE_TO_ONE: 18,
    SESSION_COMPLETE_ONE_TO_ONE: 19,
    COMPLETE_SESSION_REMINDER: 20,
    CIRCUIT_COMMENT: 26,
    SESSION_REPLY_AUTHOR: 27,
    SESSION_COMMENT: 28
};

export const NOTIFICATION_FEED_TYPES = [
    NOTIFICATION_TYPE_ENUM.FEED_COMMENT_TEAM,
    NOTIFICATION_TYPE_ENUM.FEED_COMMENT_ONE_TO_ONE,
    NOTIFICATION_TYPE_ENUM.FEED_REPLY_AUTHOR_TEAM,
    NOTIFICATION_TYPE_ENUM.FEED_REPLY_DISCUSSION_TEAM,
    NOTIFICATION_TYPE_ENUM.FEED_REPLY_ONE_TO_ONE,
    NOTIFICATION_TYPE_ENUM.FEED_LIKE_TEAM,
    NOTIFICATION_TYPE_ENUM.FEED_LIKE_ONE_TO_ONE
];

export const NOTIFICATION_TYPES_TO_CAL_DRAWER = [
    NOTIFICATION_TYPE_ENUM.EXERCISE_COMMENT,
    NOTIFICATION_TYPE_ENUM.SESSION_REPLY,
    NOTIFICATION_TYPE_ENUM.SESSION_REPLY_LIKE,
    NOTIFICATION_TYPE_ENUM.SESSION_SUMMARY_COMMENT,
    NOTIFICATION_TYPE_ENUM.SESSION_SUMMARY_COMMENT_SHARE_WITH_TEAM,
    NOTIFICATION_TYPE_ENUM.SESSION_LIKE,
    NOTIFICATION_TYPE_ENUM.SESSION_COMPLETE_ONE_TO_ONE,
    NOTIFICATION_TYPE_ENUM.CIRCUIT_COMMENT,
    NOTIFICATION_TYPE_ENUM.SESSION_REPLY_AUTHOR,
    NOTIFICATION_TYPE_ENUM.SESSION_COMMENT
];

export type Actor = {
    id: number,
    nameFirst: string,
    nameLast: string,
    imageProfile: string
};

export type Notification = {
    id: number,
    type: number,
    isRead: boolean,
    isViewed: boolean,
    type: number,
    timestampCreated: number,
    title: string,
    body: string,
    actor: Actor,
    metadata: object
};

export type NotificationLookup = {
    [key: number]: Notification
};

export const isMessagingNotificationType = (notificationType: number) => {
    return (
        notificationType === NOTIFICATION_TYPE_ENUM.FEED_COMMENT_ONE_TO_ONE ||
        notificationType === NOTIFICATION_TYPE_ENUM.FEED_COMMENT_TEAM ||
        notificationType === NOTIFICATION_TYPE_ENUM.FEED_LIKE_ONE_TO_ONE ||
        notificationType === NOTIFICATION_TYPE_ENUM.FEED_LIKE_TEAM ||
        notificationType === NOTIFICATION_TYPE_ENUM.FEED_REPLY_AUTHOR_TEAM ||
        notificationType ===
            NOTIFICATION_TYPE_ENUM.FEED_REPLY_DISCUSSION_TEAM ||
        notificationType === NOTIFICATION_TYPE_ENUM.FEED_REPLY_ONE_TO_ONE
    );
};
